import BaseModel from "../BaseModel";

export default class SampleNoteType extends BaseModel {
    static entity = 'sampleNoteTypes';
    static primaryKey = "uuid";
    static fields(){
        return {
            uuid: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            //Relations
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }

    static name(){
        return "SampleNoteType"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/sampleNoteTypes';
    }
    
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
